import type { IconProps } from "@/types/IconProps";

import { Email } from "./Email";
import { Facebook } from "./Facebook";
import { Globe } from "./Globe";
import { Help } from "./Help";
import { Instagram } from "./Instagram";
import { Linkedin } from "./Linkedin";
import { Location } from "./Location";
import { Pen } from "./Pen";
import { Phone } from "./Phone";
import { Security } from "./Security";
import { Tiktok } from "./Tiktok";
import { X } from "./X";
import { Youtube } from "./Youtube";

const iconMap = {
  email: Email,
  facebook: Facebook,
  globe: Globe,
  help: Help,
  instagram: Instagram,
  linkedin: Linkedin,
  location: Location,
  pen: Pen,
  phone: Phone,
  security: Security,
  tiktok: Tiktok,
  x: X,
  youtube: Youtube,
} as const;

export type IconName = keyof typeof iconMap;

export type IconResolverProps = {
  name: IconName;
} & IconProps;

export function IconResolver({ name, ...props }: IconResolverProps) {
  const IconComponent = iconMap[name];

  if (!IconComponent) {
    return null;
  }

  return <IconComponent {...props} />;
}
